var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTesting1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "30px",
    width: "30px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E1E5EA"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64,353.176V120.672c0-4.128,3.528-7.504,7.832-7.504H440.16c4.304,0,7.832,3.376,7.832,7.504v232.496H64V353.176z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636363"
    },
    d: "M448,353.176v32c0,4.4-3.528,8-7.832,8H71.832c-4.304,0-7.832-3.6-7.832-8v-32H448L448,353.176z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C9C9C9"
    },
    points: "200,449.176 312,449.176 304,393.176 208,393.176 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAAAAA"
    },
    points: "304,393.176 208,393.176 203.016,428.08 305.864,406.224 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 449.2,
    style: {
      fill: "#636363"
    },
    width: 168,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#939393"
    },
    points: "208,393.176 304,393.176 304.544,396.96 205.512,410.624 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 153.04,
    y: 288,
    style: {
      fill: "#E1E5EA"
    },
    width: 205.976,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.84,
    y: 312.96,
    style: {
      fill: "#E1E5EA"
    },
    width: 290.32,
    height: 8
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8AD5DD"
    },
    cx: 147.312,
    cy: 209.84,
    r: 40.08
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#333333"
    },
    points: "144.32,227.648 129.296,212.624 134.952,206.968 143.664,215.68 160.696,194.456  166.936,199.456 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8AD5DD"
    },
    cx: 254.44,
    cy: 209.84,
    r: 40.08
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#333333"
    },
    points: "251.448,227.648 236.424,212.624 242.08,206.968 250.792,215.68 267.832,194.456  274.064,199.456 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8AD5DD"
    },
    cx: 364.688,
    cy: 209.84,
    r: 40.08
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#333333"
    },
    points: "361.688,227.648 346.672,212.624 352.328,206.968 361.032,215.68 378.072,194.456  384.304,199.456 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting1);
export default __webpack_public_path__ + "static/media/testing1.9dbbbfa2d58470299595b63fe95c27b3.svg";
export { ForwardRef as ReactComponent };